// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"WV","innerWrapper":"XV","tooltipWrapper":"YV","icon":"ZV","tooltip":"_V","content":"aW"};